import { render, staticRenderFns } from "./Todo.vue?vue&type=template&id=048aa78a&"
import script from "./Todo.vue?vue&type=script&lang=js&"
export * from "./Todo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andy1229/專案/vue_後端網頁介面參考/研訊/shopstore_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('048aa78a')) {
      api.createRecord('048aa78a', component.options)
    } else {
      api.reload('048aa78a', component.options)
    }
    module.hot.accept("./Todo.vue?vue&type=template&id=048aa78a&", function () {
      api.rerender('048aa78a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/reserve_system_dashboard/components/TodoList/Todo.vue"
export default component.exports